import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/$id/versions/$versionId/variables")({
  staticData: {
    title: "common.variables",
  },
});
